var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
output += "\n";
output += "\n\n\n    <img src=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "asset")),"cms_thumbnail_url")), env.opts.autoescape);
output += "\"/> <figcaption title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "asset")),"generated_title"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "asset")),"generated_title"), env.opts.autoescape);
output += "</figcaption>\n    <a href=\"\" js-edit-foreign-key-btn=\"\" class=\"edit-foreign-key-btn edit-btn\">Edit</a>\n\n</li>\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html
// module id = ./enso_cms/static/enso-cms/nunjucks-templates/asset-manager-panel/item.html
// module chunks = main